import { DraftEventHeader } from '../DraftEventHeader';
import { Body, Container } from './ReportEventContainer.styles';
import React, { useState } from 'react';

interface Props {
  id: string;
  created?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  'data-testid'?: string;
}

export const ReportEventContainer: React.FC<Props> = ({
  defaultOpen = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Container isOpen={isOpen} data-testid={props['data-testid']}>
      <DraftEventHeader
        id={props.id}
        created={props.created}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      {isOpen && <Body>{props.children}</Body>}
    </Container>
  );
};
